import type { ReactNode } from 'react'
import { Logo } from '../components/Logo'

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-safe pt-safe pb-safe">
      <div className="w-full max-w-sm rounded-2xl border border-line bg-card px-5 py-8">
        <div className="mb-8 flex justify-center">
          <Logo className="text-lg" />
        </div>
        {children}
      </div>
    </div>
  )
}
